// Tracks which Discord user this browser instance last signed in as. Several Discord accounts can
// use the same client, and while cached profiles and titles are namespaced by user id, the Arise
// auth token in local storage is not - it *is* the identity, so it has to be replaced (not reused)
// when the Discord user changes.
export const LS_LAST_DISCORD_USER_ID = 'ARISE_LAST_DISCORD_USER_ID';

// Records the Discord user and returns true if it differs from the one we last saw here
export function syncDiscordUserIdentity(discordUserId: string): boolean {
    try {
        if (!discordUserId) return false;

        const previous = localStorage.getItem(LS_LAST_DISCORD_USER_ID);
        localStorage.setItem(LS_LAST_DISCORD_USER_ID, discordUserId);

        if (!previous || previous === discordUserId) return false;

        console.log(`[Arise] Discord user changed (${previous} -> ${discordUserId})`);
        return true;
    } catch (error) {
        console.error('syncDiscordUserIdentity error: Could not read local identity', error);
        return false;
    }
}
